import React, { useState, useEffect, useRef } from 'react';
import Select, { OptionTypeBase } from 'react-select';
import {
  FormControlLabel,
  Switch,
  withStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Tooltip,
  IconButton,
} from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Async from 'react-select/async';
import { FaInfoCircle } from 'react-icons/fa';
import {
  ContainerResumoFiltros,
  SecaoPreco,
  TextoDescricao,
  CaixaInformacao,
} from './styles';
import {
  SecaoFiltros,
  SecaoTitulo,
} from '../../../../components/FiltrosDrawer/styles';
import FiltrosDrawer from '../../../../components/FiltrosDrawer';
import ISelect from '../../../../interfaces/selectOptions';
import api from '../../../../services/api';
import Slider from '../../../../components/Slider';
import upper from '../../../../utils/UppercaseOnlyFirstLetter';
import * as colors from '../../../../config/Colors/Ligth';
import ICliente from '../../../../interfaces/cliente';
import GetNomeClientesConfig from '../../../../utils/GetNomeClientesConfig';

const OrangeSwitch = withStyles({
  switchBase: {
    color: '#ccc',
    '&$checked': {
      color: colors.colorLoginButton,
    },
    '&$checked + $track': {
      backgroundColor: colors.colorLoginButton,
    },
  },
  checked: {},
  track: {
    backgroundColor: '#ccc',
  },
})(Switch);

interface IConfigVendedor {
  modo_exibicao_cliente: number;
}

interface IFiltros {
  grupos_selecionados: ISelect[];
  setGruposSelecionados: (grupo_produto: ISelect[]) => void;
  estoque_minimo: number;
  setEstoqueMinimo: (estoque_minimo: number) => void;
  mostra_filtros: boolean;
  setMostraFiltros: (mostra: boolean) => void;
  exibe_estoque: boolean;
  setExibeEstoque: (exibe_estoque: boolean) => void;
  exibe_cliente: boolean;
  setExibeCliente: (exibe_cliente: boolean) => void;
  cliente: number;
  setCliente: (cliente: number) => void;
  prazo: number;
  setPrazo: (prazo: number) => void;
  exibe_preco: boolean;
  setExibePreco: (exibe_preco: boolean) => void;
  grupo_cliente: number;
  setGrupoCliente: (grupo_cliente: number) => void;
  tabela_preco: number;
  setTabelaPreco: (tabela_preco: number) => void;
}

interface IParam {
  filtros: IFiltros;
}

const Filtros: React.FC<IParam> = ({ filtros }) => {
  const {
    exibe_estoque,
    exibe_preco,
    estoque_minimo,
    mostra_filtros,
    cliente,
    grupos_selecionados,
    prazo,
    grupo_cliente,
    tabela_preco,
    setCliente,
    setEstoqueMinimo,
    setExibePreco,
    setExibeEstoque,
    setGruposSelecionados,
    setMostraFiltros,
    setPrazo,
    setGrupoCliente,
    setTabelaPreco,
  } = filtros;

  const time = useRef<NodeJS.Timeout | null>();
  const [grupos_produtos, setGruposProdutos] = useState<ISelect[]>([]);
  const [grupos_clientes, setGruposClientes] = useState<ISelect[]>([]);
  const [prazos, setPrazos] = useState<ISelect[]>([]);
  const [tabelas_preco, setTabelasPreco] = useState<ISelect[]>([]);
  const [prazo_temp, setPrazoTemp] = useState<
    OptionTypeBase | ISelect | number
  >(prazo || 0);
  const [cliente_temp, setClienteTemp] = useState<OptionTypeBase | number>(
    cliente || 0,
  );
  const [grupos_selecionados_temp, setGruposSelecionadosTemp] =
    useState<ISelect[]>(grupos_selecionados);
  const [grupo_cliente_temp, setGrupoClienteTemp] = useState<
    OptionTypeBase | ISelect | number
  >(grupo_cliente || 0);
  const [tabela_preco_temp, setTabelaPrecoTemp] = useState<
    OptionTypeBase | ISelect | number
  >(tabela_preco || 0);
  const [exibe_estoque_temp, setExibeEstoqueTemp] = useState<boolean>(
    exibe_estoque || false,
  );
  const [exibe_preco_temp, setExibePrecoTemp] = useState<boolean>(
    exibe_preco || false,
  );
  const [estoque_minimo_temp, setEstoqueMinimoTemp] = useState(
    estoque_minimo || 0,
  );
  const [estoque_maximo, setEstoqueMaximo] = useState(1000);
  const [step, setStep] = useState(1);
  const [mostraAjudaPreco, setMostraAjudaPreco] = useState(false);

  useEffect(() => {
    async function getGruposProdutos(): Promise<void> {
      const { data } = await api.get<ISelect[]>('grupo-produto');
      setGruposProdutos(data);
    }

    async function getGruposClientes(): Promise<void> {
      const { data } = await api.get<ISelect[]>('grupo-cliente');
      setGruposClientes(data);
    }

    async function getPrazos(): Promise<void> {
      const { data } = await api.get<ISelect[]>('prazo');
      setPrazos(data);
    }

    async function getTabelasPreco(): Promise<void> {
      const { data } = await api.get<ISelect[]>('tabela-preco');
      setTabelasPreco(data);
    }

    async function getMaiorEstoque(): Promise<void> {
      const response = await api.get('estoque-max');

      setEstoqueMaximo(1000);
      setStep(10);

      if (response.data && Number(response.data) > 1000) {
        setEstoqueMaximo(10000);
        setStep(100);
      }
      if (response.data && Number(response.data) > 10000) {
        setEstoqueMaximo(100000);
        setStep(1000);
      }
      if (response.data && Number(response.data) > 100000) {
        setEstoqueMaximo(1000000);
        setStep(10000);
      }
      if (response.data && Number(response.data) > 1000000) {
        setEstoqueMaximo(10000000);
        setStep(100000);
      }
    }

    getPrazos();
    getGruposProdutos();
    getGruposClientes();
    getTabelasPreco();
    getMaiorEstoque();
  }, []);

  function handleAplicarFiltros(): void {
    setEstoqueMinimo(estoque_minimo_temp);
    setGruposSelecionados(grupos_selecionados_temp);
    setCliente(
      cliente_temp &&
        typeof cliente_temp === 'object' &&
        'value' in cliente_temp
        ? cliente_temp.value
        : (cliente_temp as number) || 0,
    );
    setPrazo(
      prazo_temp && typeof prazo_temp === 'object' && 'value' in prazo_temp
        ? prazo_temp.value
        : (prazo_temp as number) || 0,
    );
    setGrupoCliente(
      grupo_cliente_temp && typeof grupo_cliente_temp === 'object'
        ? grupo_cliente_temp.value
        : grupo_cliente_temp || 0,
    );
    setTabelaPreco(
      tabela_preco_temp && typeof tabela_preco_temp === 'object'
        ? tabela_preco_temp.value
        : tabela_preco_temp || 0,
    );
    setExibeEstoque(exibe_estoque_temp);
    setExibePreco(exibe_preco_temp);
    setMostraFiltros(false);
  }

  async function loadClientes(filter: string): Promise<ISelect[]> {
    const config = await api.get<IConfigVendedor>(
      'busca-configuracao-vendedor',
    );

    const response = await api.get('clientes', {
      params: { q: filter, cod: [201, 202] },
    });
    const configuracao = config.data ? config.data.modo_exibicao_cliente : 0;
    const corrigeKeys = response.data.data
      .filter((cli: ICliente) => cli.ativo === true)
      .map(cli => {
        return {
          value: cli.id,
          label: GetNomeClientesConfig(cli, configuracao),
        };
      });
    return corrigeKeys;
  }

  const loadClientesOptions = (inputValue: string, callback): void => {
    if (time.current) {
      clearTimeout(time.current);
    }
    time.current = setTimeout(async () => {
      callback(await loadClientes(inputValue));
    }, 1000);
  };

  const handleGrupoClienteChange = (
    value: OptionTypeBase | ISelect | number | null,
  ): void => {
    // Sempre limpar os outros campos primeiro
    setTabelaPrecoTemp(0);
    setClienteTemp(0);
    // Depois definir o novo valor
    setGrupoClienteTemp(value || 0);
  };

  const handleTabelaPrecoChange = (
    value: OptionTypeBase | ISelect | number | null,
  ): void => {
    // Sempre limpar os outros campos primeiro
    setGrupoClienteTemp(0);
    setClienteTemp(0);
    // Depois definir o novo valor
    setTabelaPrecoTemp(value || 0);
  };

  const handleClienteChange = (value: OptionTypeBase | number | null): void => {
    // Sempre limpar os outros campos primeiro
    setGrupoClienteTemp(0);
    setTabelaPrecoTemp(0);
    // Depois definir o novo valor
    setClienteTemp(value || 0);
  };

  // Garantir exclusão mútua: quando cliente é selecionado, limpar os outros
  useEffect(() => {
    const clienteAtivo = cliente_temp && cliente_temp !== 0;
    const grupoAtivo = grupo_cliente_temp && grupo_cliente_temp !== 0;
    const tabelaAtiva = tabela_preco_temp && tabela_preco_temp !== 0;

    if (clienteAtivo && (grupoAtivo || tabelaAtiva)) {
      if (grupoAtivo) {
        setGrupoClienteTemp(0);
      }
      if (tabelaAtiva) {
        setTabelaPrecoTemp(0);
      }
    }
  }, [cliente_temp, grupo_cliente_temp, tabela_preco_temp]);

  // Garantir exclusão mútua: quando grupo de clientes é selecionado, limpar os outros
  useEffect(() => {
    const clienteAtivo = cliente_temp && cliente_temp !== 0;
    const grupoAtivo = grupo_cliente_temp && grupo_cliente_temp !== 0;
    const tabelaAtiva = tabela_preco_temp && tabela_preco_temp !== 0;

    if (grupoAtivo && (clienteAtivo || tabelaAtiva)) {
      if (clienteAtivo) {
        setClienteTemp(0);
      }
      if (tabelaAtiva) {
        setTabelaPrecoTemp(0);
      }
    }
  }, [cliente_temp, grupo_cliente_temp, tabela_preco_temp]);

  // Garantir exclusão mútua: quando tabela de preços é selecionada, limpar os outros
  useEffect(() => {
    const clienteAtivo = cliente_temp && cliente_temp !== 0;
    const grupoAtivo = grupo_cliente_temp && grupo_cliente_temp !== 0;
    const tabelaAtiva = tabela_preco_temp && tabela_preco_temp !== 0;

    if (tabelaAtiva && (clienteAtivo || grupoAtivo)) {
      if (clienteAtivo) {
        setClienteTemp(0);
      }
      if (grupoAtivo) {
        setGrupoClienteTemp(0);
      }
    }
  }, [cliente_temp, grupo_cliente_temp, tabela_preco_temp]);

  return (
    <>
      <ContainerResumoFiltros>
        <p>
          {`Filtros ativos: Grupos:
            ${
              grupos_selecionados.length > 0
                ? grupos_selecionados.map(grupo => ` ${upper(grupo.label)}`)
                : 'Todos'
            }
            - Estoque maior ou igual a ${estoque_minimo}${
            grupo_cliente
              ? ` - Grupo de Clientes: ${
                  grupos_clientes.find(g => g.value === grupo_cliente)?.label ||
                  ''
                }`
              : ''
          }${
            tabela_preco
              ? ` - Tabela de Preços: ${
                  tabelas_preco.find(t => t.value === tabela_preco)?.label || ''
                }`
              : ''
          }`}
        </p>
      </ContainerResumoFiltros>
      <FiltrosDrawer
        open={mostra_filtros}
        onClose={() => setMostraFiltros(false)}
        title="Filtrar produtos"
        subtitle="Configure os filtros para encontrar os produtos desejados"
        onApply={handleAplicarFiltros}
      >
        <SecaoFiltros>
          <div>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label>Grupo de produtos</label>
            <Select
              label="Grupos de produtos"
              isSearchable={false}
              value={grupos_selecionados_temp}
              defaultValue={grupos_selecionados_temp}
              options={grupos_produtos}
              onChange={(value: any) => {
                setGruposSelecionadosTemp(value || []);
              }}
              closeMenuOnSelect={false}
              isMulti
              name="grupos_produtos"
              placeholder="Todos os grupos"
              menuPortalTarget={document.body}
              menuShouldScrollIntoView={false}
              styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
              }}
              theme={theme => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: colors.backgroudColor,
                  primary: colors.labelFontColor,
                },
              })}
            />
          </div>
          <div>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label>Estoque mínimo</label>
            <Slider
              value={estoque_minimo_temp}
              setValue={setEstoqueMinimoTemp}
              max={estoque_maximo}
              step={step}
              titulo={`Estoque maior ou igual a ${estoque_minimo_temp}`}
            />
          </div>
        </SecaoFiltros>
        <SecaoFiltros>
          <SecaoTitulo style={{ marginBottom: 0 }}>Exibição</SecaoTitulo>
          <TextoDescricao style={{ marginTop: '-10px', marginBottom: '10px' }}>
            Defina quais valores serão exibidos
          </TextoDescricao>
          <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
            <FormControlLabel
              control={
                <OrangeSwitch
                  checked={exibe_estoque_temp}
                  onChange={() => setExibeEstoqueTemp(!exibe_estoque_temp)}
                  name="exibe_estoque"
                />
              }
              label="Exibir estoque"
            />
            <FormControlLabel
              control={
                <OrangeSwitch
                  checked={exibe_preco_temp}
                  onChange={() => {
                    const novoValor = !exibe_preco_temp;
                    setExibePrecoTemp(novoValor);
                    if (!novoValor) {
                      setClienteTemp(0);
                      setTabelaPrecoTemp(0);
                      setPrazoTemp(0);
                      setGrupoClienteTemp(0);
                    }
                  }}
                  name="exibe_preco"
                />
              }
              label="Exibir preço"
            />
          </div>
        </SecaoFiltros>
        {exibe_preco_temp && (
          <SecaoPreco>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '0px',
              }}
            >
              <SecaoTitulo style={{ marginBottom: 0 }}>
                Preço do Produto
              </SecaoTitulo>
              <Tooltip title="Clique para entender como funciona a precificação">
                <IconButton
                  size="small"
                  onClick={() => setMostraAjudaPreco(true)}
                  style={{
                    padding: '4px',
                    marginTop: '-2px',
                  }}
                >
                  <HelpOutlineIcon
                    style={{
                      fontSize: '18px',
                      color: colors.labelFontColor,
                    }}
                  />
                </IconButton>
              </Tooltip>
            </div>
            <TextoDescricao
              style={{ marginTop: '-10px', marginBottom: '10px' }}
            >
              Defina como o preço será exibido.
            </TextoDescricao>
            <div>
              {/* eslint-disable-next-line */}
              <label id="cliente-label">Cliente</label>
              <Async
                aria-labelledby="cliente-label"
                inputId="cliente-input"
                name="aria-live-color"
                classNamePrefix="react-select"
                isClearable
                value={
                  cliente_temp &&
                  cliente_temp !== 0 &&
                  typeof cliente_temp === 'object' &&
                  'value' in cliente_temp
                    ? (cliente_temp as OptionTypeBase)
                    : null
                }
                placeholder="Pesquise por Nome, Cpf/Cnpj ou Cidade"
                cacheOptions
                loadOptions={loadClientesOptions}
                defaultOptions
                onChange={handleClienteChange}
                menuPortalTarget={document.body}
                menuShouldScrollIntoView={false}
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 9999 }),
                }}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: colors.backgroudColor,
                    primary: colors.labelFontColor,
                  },
                })}
              />
            </div>
            <div>
              {/* eslint-disable-next-line */}
              <label id="tabela-preco-label">Tabela de preços</label>
              <Select
                aria-labelledby="tabela-preco-label"
                label="Tabela de preços"
                isSearchable={false}
                isClearable
                defaultValue={tabela_preco_temp}
                value={tabela_preco_temp}
                options={tabelas_preco}
                onChange={handleTabelaPrecoChange}
                placeholder="Nenhuma tabela selecionada..."
                menuPortalTarget={document.body}
                menuShouldScrollIntoView={false}
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 9999 }),
                }}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: colors.backgroudColor,
                    primary: colors.labelFontColor,
                  },
                })}
              />
            </div>
            <div>
              {/* eslint-disable-next-line */}
              <label id="grupo-produto-label">Grupo de clientes</label>
              <Select
                aria-labelledby="grupo-produto-label"
                label="Grupo de clientes"
                isSearchable={false}
                isClearable
                defaultValue={grupo_cliente_temp}
                value={grupo_cliente_temp}
                options={grupos_clientes}
                onChange={handleGrupoClienteChange}
                placeholder="Nenhum grupo selecionado..."
                menuPortalTarget={document.body}
                menuShouldScrollIntoView={false}
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 9999 }),
                }}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: colors.backgroudColor,
                    primary: colors.labelFontColor,
                  },
                })}
              />
            </div>
            <div>
              {/* eslint-disable-next-line */}
              <label id="prazo-label">Prazo</label>
              <Select
                aria-labelledby="prazo-label"
                label="Prazos"
                isSearchable={false}
                isClearable
                defaultValue={prazo_temp}
                value={prazo_temp}
                options={prazos}
                onChange={value => setPrazoTemp(value || 0)}
                placeholder="Nenhum prazo selecionado..."
                menuPortalTarget={document.body}
                menuShouldScrollIntoView={false}
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 9999 }),
                }}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: colors.backgroudColor,
                    primary: colors.labelFontColor,
                  },
                })}
              />
            </div>
            <CaixaInformacao>
              <FaInfoCircle />
              <p>
                {grupo_cliente_temp ||
                cliente_temp ||
                tabela_preco_temp ||
                prazo_temp
                  ? `Preço calculado por: ${
                      grupo_cliente_temp &&
                      typeof grupo_cliente_temp === 'object' &&
                      'label' in grupo_cliente_temp
                        ? `Grupo de clientes ${grupo_cliente_temp.label}`
                        : ''
                    }${
                      cliente_temp &&
                      typeof cliente_temp === 'object' &&
                      'label' in cliente_temp
                        ? `${grupo_cliente_temp ? ' • ' : ''}Cliente ${
                            cliente_temp.label
                          }`
                        : ''
                    }${
                      tabela_preco_temp &&
                      typeof tabela_preco_temp === 'object' &&
                      'label' in tabela_preco_temp
                        ? `${
                            grupo_cliente_temp || cliente_temp ? ' • ' : ''
                          }Tabela ${tabela_preco_temp.label}`
                        : ''
                    }${
                      prazo_temp &&
                      typeof prazo_temp === 'object' &&
                      'label' in prazo_temp
                        ? `${
                            grupo_cliente_temp ||
                            cliente_temp ||
                            tabela_preco_temp
                              ? ' • '
                              : ''
                          }Prazo ${prazo_temp.label}`
                        : ''
                    }`
                  : 'O preço padrão do produto será exibido'}
              </p>
            </CaixaInformacao>
          </SecaoPreco>
        )}
      </FiltrosDrawer>
      <Dialog
        open={mostraAjudaPreco}
        onClose={() => setMostraAjudaPreco(false)}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <DialogTitle id="dialog-title">Como o preço é definido?</DialogTitle>
        <DialogContent>
          <DialogContentText id="dialog-description">
            <p style={{ marginBottom: '12px' }}>
              <strong>Sem filtros:</strong> mostramos o preço padrão do produto.
            </p>
            <p style={{ marginBottom: '12px' }}>
              <strong>Grupo de clientes:</strong> o preço segue as regras do
              grupo escolhido.
            </p>
            <p style={{ marginBottom: '12px' }}>
              <strong>Cliente:</strong> o preço considera as condições e
              descontos desse cliente.
            </p>
            <p style={{ marginBottom: '12px' }}>
              <strong>Tabela de preços:</strong> usamos os valores da tabela
              selecionada.
            </p>
            <p style={{ marginBottom: '12px' }}>
              <strong>Prazo de pagamento:</strong> pode alterar o preço e pode
              ser combinado com qualquer opção acima.
            </p>
            <p
              style={{
                marginTop: '16px',
                marginBottom: '8px',
                fontWeight: 600,
              }}
            >
              ⚠️ Importante:
            </p>
            <p style={{ marginBottom: '8px' }}>
              Só é possível escolher um entre Grupo, Cliente ou Tabela de preços
              por vez.
            </p>
            <p>
              Se não existir preço para o filtro escolhido, será exibido o preço
              padrão.
            </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setMostraAjudaPreco(false)}
            color="primary"
            autoFocus
          >
            Entendi
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Filtros;
